import { get, post } from '@/utils/request';
import type { OnlyOfficeConfig, OnlyOfficeEditDTO, OnlyOfficeSaveDTO, OnlyOfficeFile } from '../types/onlyoffice';

const BASE_URL = '/cmp-doc/onlyoffice';

/** 获取 OnlyOffice 配置 */
export function getOnlyOfficeConfig(data: Partial<OnlyOfficeEditDTO>) {
  return post<any>(`${BASE_URL}/config`, data);
}

/** 保存 OnlyOffice 文档 */
export function saveOnlyOfficeDoc(data: Partial<OnlyOfficeFile>) {
  return post<any>(`${BASE_URL}/save`, data);
}

/** OnlyOffice 回调 */
export function onlyOfficeCallback(fileId: string, data: any) {
  return post<string>(`${BASE_URL}/callback?fileId=${fileId}`, data);
}

/** 获取 OnlyOffice 回调状态 */
export function getOnlyOfficeCallbackStatus(fileKey: string) {
  return get<OnlyOfficeFile>(`${BASE_URL}/getCallbackStatus?fileKey=${fileKey}`);
}

// 发送 forceSave 方法
// export const forceSaveApi = (key: string, userdata?: any, token?: string) => {
//   return request("/api/document/forceSave", {
//       key: key,
//       userdata: userdata || "sample userdata",
//       token: token || "YOUR_GENERATED_TOKEN"
//   })
// }

// 关闭文档
export function closeDocument(data: any) {
  return post<any>(`${BASE_URL}/closeDocument/${data.key}`, {});
}

// 同同步字段域（工程中用到的所有字段域）
export function syncProjectField(docId: string, data: any) {
  return post<any>(`/cmp-doc/project-field/sync/${docId}`, data);
}
